import request from '../request';
import {RequestPageData, RequestReturnPromise, ResponsePageData} from './type';
import {WrongListRes} from './WrongTypes';
// /api-answer-card/mp/xkw/correction/tag/list
export interface CorrectionTagList {
  id: number;
  name: string;
  remark: string;
}
export const getCorrectionTagList = (): RequestReturnPromise<
  Array<CorrectionTagList>
> => {
  return request({
    url: '/api-answer-card/mp/xkw/correction/tag/list',
    method: 'get',
  });
};
// /api-answer-card/mp/xkw/correction/tag/modify

export interface RequestModifyCorrectionTag {
  id?: number;
  name: string;
  remark?: string;
}
export const modifyCorrectionTag = (
  data: RequestModifyCorrectionTag,
): RequestReturnPromise<RequestModifyCorrectionTag> => {
  return request({
    url: '/api-answer-card/mp/xkw/correction/tag/modify',
    method: 'post',
    data,
  });
};
// /api-answer-card/mp/xkw/correction/countForUserFirstPage
export interface CorrectionCountForUserFirstPage {
  countForSubjectList: Array<{
    subjectId: number;
    questionCt: number;
    kpointCt: number;
    userId: number;
  }>;
  kpointCt: number;
  questionCt: number;
  todayQuestionCt: number;
  todayKpointCt: number;
}
export const getCorrectionCountForUserFirstPage =
  (): RequestReturnPromise<CorrectionCountForUserFirstPage> => {
    return request({
      url: '/api-answer-card/mp/xkw/correction/countForUserFirstPage',
      method: 'get',
    });
  };
// 删除标签 /api-answer-card/mp/xkw/correction/tag/delete
export const deleteCorrectionTag = (data: {
  id: number;
}): RequestReturnPromise<any> => {
  return request({
    url: '/api-answer-card/mp/xkw/correction/tag/delete?id=' + data.id,
    method: 'post',
    data,
  });
};

/**
 * TOC-分页列表
 * @param {string} search_EQ_subjectId 科目
 * @param {string} search_EQ_masteryDegree 掌握程度，0-不懂，30-了解，50-熟悉，100-熟练
 * @param {string} inputTimeType 时间范围类型，week-周，month-月，term-学期，defined-自定义
 * @param {string} search_GTE_inputTime 录入时间开始
 * @param {string} search_LTE_inputTime 录入时间结束
 * @param {string} page 页码
 * @param {string} size 每页条数
 * @returns
 */

export interface WrongListReq {
  search_EQ_subjectId: number;
  search_EQ_masteryDegree?: string;
  inputTimeType?: string;
  search_GTE_inputTime?: string;
  search_LTE_inputTime?: string;
}
export function getCorrectionPageList(
  params: RequestPageData<WrongListReq>,
): RequestReturnPromise<ResponsePageData<WrongListRes>> {
  return request({
    url: '/api-answer-card/mp/xkw/correction/page',
    method: 'get',
    params,
  });
}
// /api-answer-card/mp/xkw/correction/updateCorrectionTagByIds
export function updateCorrectionTagByIds(data: any): RequestReturnPromise<any> {
  return request({
    url:
      '/api-answer-card/mp/xkw/correction/updateCorrectionTagByIds?ids=' +
      data.ids,
    method: 'post',
    data,
  });
}

// /api-answer-card/mp/xkw/correction/get
export function getCorrectionItem(data: any): RequestReturnPromise<any> {
  return request({
    url: '/api-answer-card/mp/xkw/correction/get?id=' + data.id,
    method: 'get',
  });
}
// 生成错题下载记录/api-answer-card/mp/xkw/correction/generateCorrectionDownload
export function generateCorrectionDownload(
  data: any,
): RequestReturnPromise<any> {
  return request({
    url: '/api-answer-card/mp/xkw/correction/generateCorrectionDownload',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data,
  });
}
// /api-answer-card/mp/xkw/correction/countForUserSubjectAndMasteryDegree TOC-错题本统计（学科 + 掌握程度）维度
export function countForUserSubjectAndMasteryDegree(
  params: any,
): RequestReturnPromise<any> {
  return request({
    url: '/api-answer-card/mp/xkw/correction/countForUserSubjectAndMasteryDegree',
    method: 'get',
    params,
  });
}
// /api-answer-card/mp/xkw/correction/countForUserSubjectAndInputDay TOC-错题本统计（学科 + 日期）维度
export function countForUserSubjectAndInputDay(
  params: any,
): RequestReturnPromise<any> {
  return request({
    url: '/api-answer-card/mp/xkw/correction/countForUserSubjectAndInputDay',
    method: 'get',
    params,
  });
}
// /api-answer-card/mp/xkw/correction/countForUserSubject TOC-错题本统计（学科）维度
export function countForUserSubject(params: any): RequestReturnPromise<any> {
  return request({
    url: '/api-answer-card/mp/xkw/correction/countForUserSubject',
    method: 'get',
    params,
  });
}
// /api-answer-card/mp/xkw/correction/countForUserSubjectAndKpoint TOC-错题本统计（知识点）维度
export function countForUserSubjectAndKpoint(
  params: any,
): RequestReturnPromise<any> {
  return request({
    url: '/api-answer-card/mp/xkw/correction/countForUserSubjectAndKpoint',
    method: 'get',
    params,
  });
}
